"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeJsonFile = exports.readJsonFile = exports.readDirectory = exports.makeDirectory = exports.Files = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const structures_1 = require("@krauters/structures");
const fs_1 = require("fs");
let Files = class Files {
    static makeDirectory(directoryPath, options = {}) {
        const { suppressLogs = false, ...fsOptions } = options;
        if (!(0, fs_1.existsSync)(directoryPath)) {
            (0, fs_1.mkdirSync)(directoryPath, { recursive: true, ...fsOptions });
            if (!suppressLogs) {
                logger_1.log.debug(`Directory created at [${directoryPath}]`);
            }
            return `created [${directoryPath}]`;
        }
        else {
            if (!suppressLogs) {
                logger_1.log.debug(`Directory found at [${directoryPath}]`);
            }
            return `found [${directoryPath}]`;
        }
    }
    static readDirectory(directoryPath, options = { encoding: structures_1.FileEncoding.UTF8 }) {
        return (0, fs_1.readdirSync)(directoryPath, options);
    }
    static readJsonFile(filePath, options = { encoding: structures_1.FileEncoding.UTF8 }) {
        const content = (0, fs_1.readFileSync)(filePath, options);
        return JSON.parse(content);
    }
    static writeJsonFile(filePath, data, options = { encoding: structures_1.FileEncoding.UTF8 }) {
        const content = JSON.stringify(data, null, 2);
        (0, fs_1.writeFileSync)(filePath, content, options);
        logger_1.log.debug(`Data written to [${filePath}]`);
        return `written [${filePath}]`;
    }
};
exports.Files = Files;
exports.Files = Files = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Files);
exports.makeDirectory = Files.makeDirectory, exports.readDirectory = Files.readDirectory, exports.readJsonFile = Files.readJsonFile, exports.writeJsonFile = Files.writeJsonFile;
//# sourceMappingURL=files.js.map